module.exports = __webpack_public_path__ + "images/location-cluster.d3dbd7a18d5c6104539e.svg";